import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-position-arrow-up",
  "use": "icon-position-arrow-up-usage",
  "viewBox": "0 0 16 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 9\" id=\"icon-position-arrow-up\"><defs><style>#icon-position-arrow-up .cls-1{fill:currentColor;}</style></defs><path class=\"cls-1\" d=\"M0,7.78a1.15,1.15,0,0,0,.38.87A1.32,1.32,0,0,0,1.3,9a1.29,1.29,0,0,0,.9-.37L8,3l5.8,5.68a1.33,1.33,0,0,0,1.82,0A1.17,1.17,0,0,0,16,7.78a1.08,1.08,0,0,0-.35-.8L9,.37A1.38,1.38,0,0,0,8,0a1.11,1.11,0,0,0-.9.37L.35,7a1.08,1.08,0,0,0-.35.8Z\" transform=\"translate(0 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol